<div class="row">
  <div class="card shadow-none rounded">
    <form [formGroup]="profitform">
      <div class="card-body">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
          <div class="row">
            <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-10">
              <h4 class="fw-bold"> Reserves / Retained profit - {{commonService.headerName}}</h4>
            </div>
            <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-2 text-start text-sm-end p-sm-0 pt-2">
              <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;"
                      tabindex="-1" (click)="TotalBack()">
                Close Accounts
              </button>
            </div>
          </div>
        </div>
        <hr />

        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
          <div class="row">
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <!--<h5 class="fw-bolder font-size-16">Reserves / Retained profit</h5>-->
              <div class="mb-3">
                <p class="mt-4">Please enter notes on reserves/retained profit.</p>
                <p>If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
              </div>
            </div>
          </div>
          <div class="row">
              <h6 class="fw-bolder pt-3">Retained profit reconciliation</h6>
              <div class="col-12 ps-0 ps-lg-5 ">
                <div class="row mt-4 mb-2">
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <label class="pt-2">Reserves as At</label>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12">
                    <label class="pt-2">{{commonService.StartDate}}</label>
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control text-end text-end AccountNumber" [appTooltip]="showBubbledata"  appNumberdirective formControlName="ReservesAsAt" maxlength="11" (change)="calculation()" />
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <label class="pt-2">Profit for year</label>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12">
                    <label></label>
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control text-end" (change)="calculation()" formControlName="ProfitForYear"  maxlength="11" />
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <label class="pt-2">Equity dividends paid</label>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12">
                    <label></label>
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control text-end " (change)="calculation()" formControlName="EquityDividendsPaid" readonly maxlength="11" />
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <label class="pt-2">Retained profit At</label>
                  </div>
                  <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12">
                    <label class="pt-2">{{commonService.EndDate}}</label>
                  </div>
                  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="input-group">
                      <div class="input-group-text ">£</div>
                      <input type="text" class="form-control text-end " (change)="calculation()" formControlName="RetainedProfitAt"  maxlength="11" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
          <label class="color-black">Please enter any additional information in the field below.</label>
          <div class="mb-3">
            <textarea class="form-control txt-area allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective rows="4" formControlName="AdditionalInformation" maxlength="4000"></textarea>
          </div>
        </div>
          <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4 pe-0">
            <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="back()">Back</button>
            <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="save()">Next</button>
          </div>
        </div>
    </form>
    
  </div>
</div>
